<template>
    <el-select
        v-model="selectValue"
        :placeholder="i18n.tkey('lang_select_pls')"
        @change="changeValue"
        style=""
    >
        <el-option
            v-for="(v, i) in dataList"
            :key="v.countrycode"
            :label="userInfoRef.lang !== 'zh' && userInfoRef.lang !== 'szh' ? v.en : v.zh"
            :value="i"
        />
    </el-select>
</template>

<script setup>

import {hkDistrictList} from "@/util/hkDistrictCode";
import {toRef, ref, onBeforeMount, inject} from "vue";
import {useUserinfo} from "@/stores/userinfo";

const emits = defineEmits(['select-complete'])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

const selectValue = ref(null)
const dataList = ref([])

function changeValue(value){
    emits('select-complete', hkDistrictList[value])
}

onBeforeMount(() => {
    console.log(hkDistrictList)
    dataList.value = hkDistrictList
})

</script>

<style scoped>

</style>